import { defineMessages } from 'react-intl'

export default defineMessages({
  newPoll: {
    id: 'containers.SchedulingPollPage.newPoll',
    defaultMessage: 'New Poll',
  },
  title: {
    id: 'containers.SchedulingPollPage.title',
    defaultMessage: 'Title',
  },
  status: {
    id: 'containers.SchedulingPollPage.status',
    defaultMessage: 'Status',
  },
  orderId: {
    id: 'containers.SchedulingPollPage.orderId',
    defaultMessage: 'Order ID',
  },
  timeSlots: {
    id: 'containers.SchedulingPollPage.timeSlots',
    defaultMessage: 'Time Slots',
  },
  responses: {
    id: 'containers.SchedulingPollPage.responses',
    defaultMessage: 'Responses',
  },
  created: {
    id: 'containers.SchedulingPollPage.created',
    defaultMessage: 'Created',
  },
  open: {
    id: 'containers.SchedulingPollPage.open',
    defaultMessage: 'Open',
  },
  closed: {
    id: 'containers.SchedulingPollPage.closed',
    defaultMessage: 'Closed',
  },
  none: {
    id: 'containers.SchedulingPollPage.none',
    defaultMessage: 'None',
  },
  options: {
    id: 'containers.SchedulingPollPage.options',
    defaultMessage: '{count, plural, one {# option} other {# options}}',
  },
  responsesCount: {
    id: 'containers.SchedulingPollPage.responsesCount',
    defaultMessage: '{count, plural, one {# response} other {# responses}}',
  },
  linkCopied: {
    id: 'containers.SchedulingPollPage.linkCopied',
    defaultMessage: 'Link copied to clipboard!',
  },
  linkCopyFailed: {
    id: 'containers.SchedulingPollPage.linkCopyFailed',
    defaultMessage: 'Failed to copy link',
  },
  copyParticipantLink: {
    id: 'containers.SchedulingPollPage.copyParticipantLink',
    defaultMessage: 'Copy participant link',
  },
})
